'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("moveNodePopinController", function ($scope) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.errors = {};
  $scope.saveAndClose = function () {
    $scope.errors.emplacement = $scope.document.parentId !== originalDocument.parentId ? undefined : {
      message: "Champ obligatoire"
    };
    if (!$scope.errors.emplacement) {
      _.extend(originalDocument, $scope.document);
      $scope.$close(originalDocument);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/inventaire/documents/moveNodePopin.js
// module id = 2828
// module chunks = 13